import {RouterModule, Routes} from '@angular/router';

import {ViewfineComponent} from './viewfine/viewfine.component';
import {ProcessingpayComponent} from "./processingpay/processingpay.component";
import {PayerrorComponent} from "./payerror/payerror.component";
import {ViewpdfComponent} from "./viewpdf/viewpdf.component";

import {AuthGuard} from "../services/guards/auth.guard";
import {VerifyTokenGuard} from "../services/guards/verifytoken.guard";
import {OpenedSessionGuard} from '../services/guards/opened-session.guard';
import {LegaltermsComponent} from '../sitepages/legalterms/legalterms.component';
import {CookiestermsComponent} from '../sitepages/cookiesterms/cookiesterms.component';
import {TermsconditionsComponent} from '../sitepages/termsconditions/termsconditions.component';
import {PrivacytermsComponent} from '../sitepages/privacyterms/privacyterms.component';
import {PaymentComponent} from './payment/payment.component';
import {IdentificationComponent} from './identification/identification.component';
import {SharingComponent} from './sharing/sharing.component';
import {RejectComponent} from './reject/reject.component';
import {ThankyouComponent} from './thankyou/thankyou.component';
import {PendingComponent} from './pending/pending.component';
import {FinegroupComponent} from './finegroup/finegroup.component';

/**
 * App pages Routes user area
 * 
 * @author Fran Aragon
 */
const appPagesRoutes: Routes = [
    {path: 'app/payment/:hash', component: PaymentComponent, canActivate: [AuthGuard, VerifyTokenGuard, OpenedSessionGuard]},
    {path: 'app/identify/:hash', component: IdentificationComponent, canActivate: [AuthGuard, VerifyTokenGuard, OpenedSessionGuard]},
    {path: 'app/share/:hash', component: SharingComponent, canActivate: [AuthGuard, VerifyTokenGuard, OpenedSessionGuard]},
    {path: 'app/reject/:hash', component: RejectComponent, canActivate: [AuthGuard, VerifyTokenGuard, OpenedSessionGuard]},
    {path: 'app/viewfine/:hash', component: ViewfineComponent, canActivate: [AuthGuard, VerifyTokenGuard, OpenedSessionGuard]},
    {path: 'app/finegroup/:hash', component: FinegroupComponent, canActivate: [AuthGuard, VerifyTokenGuard, OpenedSessionGuard]},
    {path: 'app/processingpay/:hash', component: ProcessingpayComponent, canActivate: [AuthGuard, VerifyTokenGuard]},
    {path: 'app/thankyou/:hash', component: ThankyouComponent, canActivate: [AuthGuard, VerifyTokenGuard]},
    {path: 'app/pending/:hash', component: PendingComponent, canActivate: [AuthGuard, VerifyTokenGuard]},
    {path: 'app/payerror/:hash', component: PayerrorComponent, canActivate: [AuthGuard, VerifyTokenGuard]},
    {path: 'app/viewpdf/:type/:exp/:hash', component: ViewpdfComponent, canActivate: [AuthGuard, VerifyTokenGuard]},
    {path: 'app/cookiesterms', component: CookiestermsComponent},
    {path: 'app/legalterms', component: LegaltermsComponent},
    {path: 'app/termsconditions', component: TermsconditionsComponent},
    {path: 'app/privacyterms', component: PrivacytermsComponent},
    {path: '', redirectTo: '/home', pathMatch: 'full'}
];

/**
 * App pages Routes user area
 */
export const APP_PAGES_ROUTES = RouterModule.forChild(appPagesRoutes);
